import { GET_CHECKIN_DETAIL } from '../Actions/actionTypes';
export default (state={},action)=>{
  switch(action.type){
    case GET_CHECKIN_DETAIL:
      return action.payload;
    default:
      return state;
  }
}